import { Card, CardContent } from '@/components/ui-kit/card';
import { AgentSummary } from '@/modules/gpt-chats/types/agent.service.type';
import { AgentCardDropDown } from './agent-card-dropdown';
import { Link } from 'react-router-dom';

export const AgentCardGridView = ({ agent }: { agent: AgentSummary }) => {
  return (
    <Card className="group h-full w-full max-w-[230px] border-0 shadow-none hover:bg-accent/50 [&:has([data-state=open])]:bg-accent/50 transition-colors duration-200">
      <CardContent className="p-0">
        <div className="relative">
          <Link to={`/ai/agent-details/${agent.id}`} className="block">
            <div className="relative aspect-square w-full overflow-hidden rounded-sm bg-muted/30">
              <img
                src={agent.logo_url || '@/assets/images/agents/widget.png'}
                alt={agent.name || 'agent_logo'}
                className="h-full w-full object-cover"
                onError={(e) => {
                  e.currentTarget.src = '@/assets/images/agents/widget.png';
                }}
              />
            </div>
            <div className="mt-3 flex flex-col gap-1 font-medium text-medium-emphasis min-w-0 pr-6">
              <h3 className="truncate text-base text-foreground" title={agent?.name}>
                {agent?.name}
              </h3>
              <p className="truncate text-xs text-muted-foreground" title={agent?.role}>
                {agent?.role || agent?.description}
              </p>
            </div>
          </Link>
          <div
            className="invisible absolute bottom-4 right-0 group-hover:visible group-[&:has([data-state=open])]:visible"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <AgentCardDropDown agent={agent} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
